export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"#4E4EDA\" d=\"M6 0a6 6 0 100 12A6 6 0 006 0m1.835 6.671l-1.5.75a.75.75 0 01-1.006-.336l-1.5-3a.75.75 0 011.342-.67l1.165 2.329.829-.415a.75.75 0 11.67 1.342\"/></g><defs><clipPath id=\"a\"><rect width=\"12\" height=\"12\" fill=\"#fff\" rx=\"6\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "12",
    "fill": "none"
  }
};